import React from "react";
import PropTypes from "prop-types";
const CategoryFilterIcon = ({
  noPointer,
  width,
  size,
  height,
  style,
  color,
  title,
  ...props
}) => (
  <svg
    {...props}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 18 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
    stroke={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-3-2h24v24H-3z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"}>
        <path
          stroke="none"
          fillRule="nonzero"
          d="M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6.138a2 2 0 0 0 1.392-.564l3.862-3.746A2 2 0 0 0 16 12.254V4a2 2 0 0 0-2-2H4zm0-2h10a4 4 0 0 1 4 4v8.254a4 4 0 0 1-1.215 2.872l-3.863 3.745A4 4 0 0 1 10.138 20H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
        />
        <rect stroke="none" width="6" height="2" x="8" y="5" rx="1" />
        <rect stroke="none" width="6" height="2" x="8" y="9" rx="1" />
        <circle stroke="none" cx="5" cy="6" r="1" />
        <circle stroke="none" cx="5" cy="10" r="1" />
        <circle stroke="none" cx="5" cy="14" r="1" />
        <path
          stroke="none"
          fillRule="nonzero"
          d="M12 15v3.186h-2V14.5a1.5 1.5 0 0 1 1.5-1.5h5.091v2H12z"
        />
      </g>
    </g>
  </svg>
);
CategoryFilterIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default CategoryFilterIcon;
